module.exports = __webpack_public_path__ + "static/media/Zarori.450e2d78.png";